module.exports = __webpack_public_path__ + "img/TH.d615b18d.png";